import React from 'react';

export const StepNodeContext = React.createContext<{
  activeStep: string;
}>(
  new Proxy({} as any, {
    get: () => {
      throw new Error('Not within a StepNodeContext');
    },
  }),
);

export const StepNodeProvider = ({
  activeStep,
  children,
}: {
  activeStep: string;
  children: React.ReactNode;
}) => {
  return (
    <StepNodeContext.Provider
      value={{
        activeStep,
      }}
    >
      {children}
    </StepNodeContext.Provider>
  );
};
